var zo = zo || {};

zo.goTop = function () {

    var $btn = $('.js-goTop');

    if (!$btn.length) {
        return;
    }

    var showAfter = 500;

    function toggleGoTop() {
        if ($(window).scrollTop() > showAfter) {
            $btn.addClass('is-visible');
        } else {
            $btn.removeClass('is-visible');
        }
    }

    $(window).on('scroll', toggleGoTop);
    toggleGoTop();

    $btn.on('click', function (e) {
        e.preventDefault();

        $('html, body').stop().animate({
            scrollTop: 0
        }, 600);
    });
};


$(document).ready(function (){
    zo.goTop();

});